@if (columnModel.isEditable && !!control) {
    <arc-currency-input [formControl]="control | formControl" [currencyId]="currencyId" />
} @else {
    <div class="w-full-h-full align-center">
        @if (hasValue) {
            <span class="truncate" [class.text-sm]="currColumnModel.isCompact" [class.font-bold]="isBold(currColumnModel.propertyName)">
                {{ value | arcCurrency: currencyIsoCode }}
            </span>
        }
    </div>
}
